// src/app/core/init/verify-session.ts
import { inject } from '@angular/core';
import { SessionService } from '../services/user-management/session.service';
import { UserService } from '../services/user-management/user.service';

export function verifySessionFactory() {
  const session = inject(SessionService);
  const user = inject(UserService);

  return () => {
    const token = session.token();
    const isValid = session.isAuthenticated();

    if (!isValid) {
      session.clearToken();
      return;
    }

    const userValue = user.userData();

    if (!userValue) {
      session.token.update((t) => t);
    }
  };
}
